/*
This regex pattern is meant to adhere to the RFC 5322 standard for email addresses.
This version is slightly modified from the one found here https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
The modification allows for spaces within the local portion of the email provided they are enclosed by double quotes.
*/
export const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[ !#-\[\]-~]|\\[ -~])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}|(?:\[(?:(?:25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\]))$/i;

// https://www.regular-expressions.info/dates.html
export const dateRegexString =
  '(0[1-9]|1[012])\\/(0[1-9]|[12][0-9]|3[01])\\/(19|20)\\d\\d';

// Should match API
// https://github.com/farmersdog/api/blob/53747aac53573063f0449acc3275c1e914998722/src/lib/utils.js
export const emailInputRegexString =
  '(([^<>\\(\\)\\[\\]\\.,;:\\s@"]+(\\.[^<>\\(\\)\\[\\]\\.,;:\\s@"]+)*)|(".+"))@(([^<>\\(\\)\\[\\]\\.,;:\\s@"]+\\.)+[^<>\\(\\)\\[\\]\\.,;:\\s@"]{2,})';

export const phoneRegexString =
  '(?:(?:\\+?1\\s*(?:[.\\-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.\\-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.\\-]\\s*)?([0-9]{4})(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?';

export const zipcodeRegexString = '(?=(?:.{5}|.{9})$)[0-9]*';
